import { StyleSheet, View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';

const styles = StyleSheet.create({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
});

export const ExportCommentarySection = ({
  title,
  subtitle,
  subjectAddress,
  children,
}: PropsWithChildren<{ title: string; subtitle?: string; subjectAddress: string }>) => (
  <View style={styles.sectionContainer} wrap>
    <View style={styles.titleContainer} wrap>
      <Text variant="subtitle1">{subjectAddress}</Text>
      <Text variant="h1">{title}</Text>
      {subtitle && <Text variant="body1">{subtitle}</Text>}
    </View>

    {children}
  </View>
);
